(function () {
  function initMobileStickyAtc() {
    const stickyBar = document.getElementById('MobileStickyAtc');
    const stickyBtn = document.getElementById('MobileStickyAtcButton');
    const stickyText = document.getElementById('MobileStickyAtcButtonText');
    const stickyPrice = document.getElementById('MobileStickyAtcPrice');

    if (!stickyBar || !stickyBtn) return;

    const mainAtcBtn = document.querySelector(
      'form[action*="/cart/add"] [type="submit"][name="add"], .product-form__submit, [name="add"], #ProductSubmitButton'
    );
    if (!mainAtcBtn) return;

    document.body.classList.add('has-mobile-sticky-atc');

    // 1. 显隐控制：只要原按钮在视口内就隐藏，不在视口内（上方或下方）均显示
    function checkVisibility() {
      if (window.innerWidth > 749) {
        stickyBar.classList.remove('is-visible');
        return;
      }

      const rect = mainAtcBtn.getBoundingClientRect();
      const inView = rect.top < window.innerHeight && rect.bottom > 0;

      if (inView) {
        stickyBar.classList.remove('is-visible');
      } else {
        stickyBar.classList.add('is-visible');
      }
    }

    // 立即执行一次
    checkVisibility();

    // 滚动与窗口缩放监听
    window.addEventListener('scroll', checkVisibility, { passive: true });
    window.addEventListener('resize', checkVisibility, { passive: true });

    // 2. 价格与变体状态同步（绝不触发死循环）
    function getActivePrice() {
      const priceContainer = document.querySelector('.product .price, #MainContent .price, [id^="price-"]');
      if (priceContainer) {
        if (priceContainer.classList.contains('price--on-sale')) {
          const saleEl = priceContainer.querySelector('.price__sale .price-item--sale, .price-item--sale');
          if (saleEl && saleEl.textContent.trim()) return saleEl.textContent.trim();
        }
        const regEl = priceContainer.querySelector('.price__regular .price-item--regular, .price-item--regular, .price-item');
        if (regEl && regEl.textContent.trim()) return regEl.textContent.trim();
      }
      return null;
    }

    function syncState() {
      // 按钮状态与文字
      if (mainAtcBtn.disabled) {
        stickyBtn.disabled = true;
        stickyText.textContent = mainAtcBtn.textContent.trim() || 'SOLD OUT';
      } else {
        stickyBtn.disabled = false;
        stickyText.textContent = mainAtcBtn.textContent.trim() || 'ADD TO CART';
      }

      // 价格同步
      const currentPrice = getActivePrice();
      if (currentPrice && stickyPrice && stickyPrice.textContent !== currentPrice) {
        stickyPrice.textContent = currentPrice;
      }
            // 3. 自动同步当前选中的颜色、尺码与套装小字
      const summaryEl = document.getElementById('MobileStickyAtcSummary');
      if (summaryEl) {
        const activeColor = document.querySelector('.compact-color-swatch-btn.is-active')?.getAttribute('data-color') || '';
        const activePill = document.querySelector('.purchase-pill-btn.is-active')?.getAttribute('data-purchase-type') || '';
        const isSet = activePill.indexOf('Bracelet') !== -1;
        const sizeRadio = document.querySelector('input[name*="Diameter"]:checked, input[name*="Inner"]:checked');
        const activeSize = sizeRadio ? sizeRadio.value : '';
        summaryEl.textContent = `${activeColor} / ${activeSize}${isSet ? ' · Set' : ''}`;
      }

    }

    // 初始同步
    syncState();

    // 仅在用户切换选项（包括 Personalized）或 Shopify 变体更新时触发，安全无循环
    document.addEventListener('change', function () {
      setTimeout(syncState, 100);
      setTimeout(syncState, 300);
    });
    document.addEventListener('variant:change', syncState);

    // 3. 点击固定栏原生代理加购
    let isSubmitting = false;
    stickyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (stickyBtn.disabled || isSubmitting) return;

      isSubmitting = true;
      stickyBtn.classList.add('is-loading');

      mainAtcBtn.click();

      setTimeout(() => {
        isSubmitting = false;
        stickyBtn.classList.remove('is-loading');
      }, 800);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileStickyAtc);
  } else {
    initMobileStickyAtc();
  }
})();

